var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29294_677)",
    filter: "url(#filter0_d_29294_677)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(4 2)",
    fill: "#0E8DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6H5V3H8V2H4V6Z",
    fill: "#E7F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 14H5V17H8V18H4V14Z",
    fill: "#E7F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6H19V3H16V2H20V6Z",
    fill: "#E7F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14H19V17H16V18H20V14Z",
    fill: "#E7F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64131 13.3325C7.9789 13.3946 8.24542 13.3591 8.50305 13.1018C9.08939 12.5072 9.70239 11.9392 10.3065 11.3624C10.5286 11.1494 10.7862 11.0517 11.0883 11.1405C11.6835 11.3002 11.9234 12.0102 11.4969 12.445C10.7685 13.1816 10.0044 13.9005 9.22265 14.5927C8.71627 15.0364 8.06774 14.9832 7.44586 14.9743C7.4281 14.9743 7.40144 14.9565 7.38368 14.9654C6.72626 15.1429 6.45974 14.5927 6.08662 14.2554C6.03331 14.2022 6.00666 14.0957 6.00666 14.0158C5.99778 13.6254 5.99778 13.2349 6.00666 12.8355C6.02443 12.4007 6.18434 12.0102 6.50416 11.6996C7.19711 11.0251 7.89006 10.3595 8.58301 9.69394C8.9206 9.36558 9.40922 9.37446 9.72904 9.69394C10.0577 10.0223 10.0577 10.5015 9.71127 10.8476C9.09828 11.4511 8.48529 12.0457 7.85453 12.6225C7.64131 12.8266 7.59689 13.0485 7.64131 13.3325Z",
    fill: "#E8F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9411 6.72115C12.0477 6.54366 12.1188 6.33067 12.261 6.18868C12.8562 5.59409 13.4692 5.00837 14.0999 4.4404C14.4642 4.11204 14.8728 3.8458 15.4059 4.10316C15.4414 4.12091 15.5036 4.12091 15.5391 4.10316C15.9656 3.89018 16.3387 4.04104 16.6585 4.30728C16.9073 4.51139 17.1027 4.76875 17.2804 5.03499C17.3692 5.16811 17.4136 5.3811 17.3781 5.54084C17.3248 5.78045 17.3337 6.00231 17.3781 6.24193C17.4581 6.68565 17.1827 7.00514 16.8895 7.29799C16.3032 7.87484 15.699 8.44281 15.0949 9.01078C14.7307 9.34801 14.2598 9.35688 13.9311 9.02853C13.6113 8.70904 13.6202 8.21207 13.9667 7.86596C14.5441 7.29799 15.1305 6.74777 15.7079 6.18868C15.9656 5.93132 15.9034 5.62071 15.5391 5.54084C15.4059 5.51421 15.2015 5.62071 15.0949 5.71833C14.5352 6.23305 14.0022 6.7744 13.4425 7.28025C13.2737 7.43111 13.0516 7.55536 12.8295 7.59085C12.3498 7.6441 11.9678 7.24475 11.9411 6.72115Z",
    fill: "#E8F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.543 14.9744C16.3387 14.9744 16.1255 14.9833 15.9212 14.9744C15.4414 14.9567 15.0861 14.6106 15.0861 14.158C15.0861 13.7231 15.4325 13.377 15.9034 13.3592C16.3387 13.3504 16.774 13.3415 17.2004 13.3592C17.6713 13.377 18 13.7142 18 14.1668C18 14.6194 17.6713 14.9478 17.1916 14.9655C16.9695 14.9833 16.7562 14.9744 16.543 14.9744Z",
    fill: "#E8F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6607 13.3592C12.874 13.3592 13.0961 13.3503 13.3093 13.3592C13.7801 13.3858 14.1177 13.7319 14.1177 14.1668C14.1177 14.6105 13.7712 14.9566 13.3004 14.9655C12.8651 14.9744 12.4298 14.9744 12.0033 14.9655C11.5325 14.9477 11.1949 14.6016 11.1949 14.1579C11.1949 13.7142 11.5414 13.3769 12.0122 13.3592C12.2254 13.3503 12.4475 13.3592 12.6607 13.3592Z",
    fill: "#E8F6F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_29294_677",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.809394 0 0 0 0 0.898158 0 0 0 0 0.917179 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29294_677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29294_677",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29294_677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ecd0c58814447d6d4a2ed5945da8740f.svg";
export { ForwardRef as ReactComponent };